import { useProxy } from '@revenuewell/logic-wrapper-proxy';
import { useContext } from 'react';
import { SelectedLocationContext, SelectedLocationContextProps } from './selected-location-context';

export const useSelectedLocation = (): SelectedLocationContextProps => {
  const context = useContext(SelectedLocationContext);

  if (!context)
    throw new Error('useSelectedLocation must be used within an SelectedLocationContext');

  return context;
};